const routes = [
  {
    path: '/equipInspection',
    name: 'equipInspection',
    redirect: "/equipInspection/standard",
    component: () => import('@src/modules/equipInspection/main'),
    meta: {
      requireAuth: false
    },
    // redirect: 'meetingRoomManage',
    children: [
      {
        path: 'standard',
        name: 'standard',
        component: () => import('@src/modules/equipInspection/view/standard'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@src/modules/equipInspection/view/plan'),
        meta: {
          requireAuth: false
        }
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@src/modules/equipInspection/view/history'),
        meta: {
          requireAuth: false
        }
      }
    ]
  }
]

export default routes
